import { render } from "./ViewCookieStatement.vue?vue&type=template&id=868c8778"
import script from "./ViewCookieStatement.vue?vue&type=script&lang=js"
export * from "./ViewCookieStatement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__